import React from "react";
import { Helmet } from "react-helmet-async";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";
import PostLoginPhonePrompt from "../../components/postLoginPhonePrompt";

const PostLoginPhonePromptContainer = () => (
  <ProtectedRoute>
    <main>
      <Helmet title="Add phone number" />
      <PostLoginPhonePrompt />
    </main>
  </ProtectedRoute>
);

export default PostLoginPhonePromptContainer;
